// Feature: AI surfaces (PLAN §13): session summary card, Why tab (Explain this
// moment, Repro), Ask Why chat drawer, natural-language search, digests,
// AI settings and usage. Register routes and nav via registerFeature().
import { createRoute } from "@tanstack/react-router";
import { registerFeature } from "../registry";
import { DigestDetailPage, DigestsPage } from "./pages/DigestsPage";
import { AiSettingsPage } from "./pages/AiSettingsPage";
import { OrgAiProvidersPage, OrgAiRoutingPage } from "./pages/OrgAiAdminPages";
import { AiUsagePage } from "./pages/AiUsagePage";
import { AskWhyPage } from "./pages/AskWhyPage";
import "./ai.css";

registerFeature({
  routes: (appRoute) => [
    createRoute({ getParentRoute: () => appRoute, path: "/ai/ask", component: AskWhyPage, validateSearch: (s: Record<string, unknown>) => s as { session?: string; cluster?: string; conversation?: string } }),
    createRoute({ getParentRoute: () => appRoute, path: "/ai/digests", component: DigestsPage }),
    createRoute({ getParentRoute: () => appRoute, path: "/ai/digests/$id", component: DigestDetailPage }),
    createRoute({ getParentRoute: () => appRoute, path: "/orgs/$org/ai", component: AiSettingsPage }),
    createRoute({ getParentRoute: () => appRoute, path: "/orgs/$org/ai/usage", component: AiUsagePage }),
    createRoute({ getParentRoute: () => appRoute, path: "/orgs/$org/ai/providers", component: OrgAiProvidersPage }),
    createRoute({ getParentRoute: () => appRoute, path: "/orgs/$org/ai/routing", component: OrgAiRoutingPage }),
  ],
  nav: [
    { label: "Digests", to: "/ai/digests", section: "main", order: 60 },
    { label: "Ask Why", to: "/ai/ask", section: "main", order: 65 },
    { label: "AI settings", to: "/orgs/$org/ai", section: "org", order: 40, needsOrg: true, scope: "admin" },
  ],
});

export { WhyPanel } from "./WhyPanel";
export type { WhyPanelProps } from "./WhyPanel";
export { SummaryCard } from "./components/SummaryCard";
export { AskWhyDrawer, AskWhyButton } from "./askwhy/AskWhyDrawer";
export { askWhy, useAskWhy } from "./askwhy/store";
export { NlSearch, interpretedToFilters } from "./NlSearch";
export { AI_UNCONFIGURED, aiApi, aiKeys, deepRequest, parseSse, rejectedMessage, savedGitHubRepositories } from "./api";
export type { DeepResult, AiSettingsExt } from "./api";
export { useAiCapability, useDeepAnalysis, useCitationSeek, useTranscript, resolveCitation } from "./hooks";
export type { AiCapabilityState, DeepState } from "./hooks";
export { AiSparkle, AiOutput, AiBlockedTooltip, AiUnavailableNote, JobStatus, Rejected, CitationChips, ArtifactMetaLine } from "./components/common";
export { ExplainArtifactView, ReproView, ClusterExplanationView, PrDraftView } from "./components/artifacts";
